import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetDataModel,
  fetchPostDataModel,
  fetchPutDataModel,
  fetchDeleteDataModel,
  cleanUpDataModel,
  cleanUpMessageDataModel
} from 'state-managament/dataModel.slice';

export default function useDataModel(project) {
  const { error, success, isLoaded, data } = useSelector((state) => state.dataModel);
  const dispatch = useDispatch();

  const getDataModel = (args) => dispatch(fetchGetDataModel(args));
  const postDataModel = (args) => dispatch(fetchPostDataModel(args));
  const deleteDataModel = (args) => dispatch(fetchDeleteDataModel(args));
  const putDataModel = (args) => dispatch(fetchPutDataModel(args));

  const cleanUp = () => dispatch(cleanUpDataModel());
  const cleanUpMessage = () => dispatch(cleanUpMessageDataModel());

  return {
    getDataModel,
    postDataModel,
    deleteDataModel,
    putDataModel,
    cleanUp,
    cleanUpMessage,
    error,
    success,
    isLoaded,
    data
  };
}
